<template>
  <div>
    <p class="text-2xl mb-6">Performance en détail</p>
    <Filters></Filters>
    <MetricsBreakdownCard />
    <ScoreProgressionChart title="Score RUM" score-type="All" />
    <CwvIssuesTable
      class="my-6"
      :show-actions="false"
      title="Suivi des tickets"
    />
    <add-edit-issue-modal />
    <delete-issue-modal />
  </div>
</template>

<script>
import Filters from "@/components/web-perf/cwv/cwv-performance-breakdown/filters/Filters.vue";
import MetricsBreakdownCard from "@/components/web-perf/cwv/cwv-performance-breakdown/cards/MetricsBreakdownCard.vue";
import ScoreProgressionChart from "@/components/web-perf/cwv/cwv-sites-performance/charts/ScoreProgressionChart.vue";
import CwvIssuesTable from "@/components/web-perf/cwv/cwv-issues/tables/IssuesTable.vue";
import AddEditIssueModal from "@/components/web-perf/cwv/cwv-issues/modals/AddEditIssueModal.vue";
import DeleteIssueModal from "@/components/web-perf/cwv/cwv-issues/modals/DeleteIssueModal.vue";

export default {
  name: "CwvPerformanceBreakdown",
  components: {
    Filters,
    MetricsBreakdownCard,
    ScoreProgressionChart,
    CwvIssuesTable,
    AddEditIssueModal,
    DeleteIssueModal,
  },
  created() {
    this.$store.commit("appConfig/UPDATE_APP_CONTENT_WIDTH", "largeWidth");
  },
  beforeDestroy() {
    this.$store.commit("appConfig/UPDATE_APP_CONTENT_WIDTH", "boxed");
  },
};
</script>
<style scoped></style>
